import { render, staticRenderFns } from "./WorkoutSplitOverviewAndSubmit.vue?vue&type=template&id=3936d23d&scoped=true"
import script from "./WorkoutSplitOverviewAndSubmit.vue?vue&type=script&lang=js"
export * from "./WorkoutSplitOverviewAndSubmit.vue?vue&type=script&lang=js"
import style0 from "./WorkoutSplitOverviewAndSubmit.vue?vue&type=style&index=0&id=3936d23d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3936d23d",
  null
  
)

export default component.exports